import React from "react";
import { Card, Typography, CardContent, CardMedia, Box, Divider } from "@mui/material";

export default function CardSearch({ data }) {
  return (
    <Card
      sx={{
        borderRadius: 3,
        boxShadow: 3,
        height: "100%",
        display: "flex",
        flexDirection: "column",
        overflow: "hidden",
        transition: "transform 0.2s ease-in-out, box-shadow 0.2s ease-in-out",
        "&:hover": {
          transform: "translateY(-3px)",
          boxShadow: 6,
        },
      }}
    >
      <Box
        sx={{
          position: "relative",
          width: "100%",
          paddingTop: "56.25%", // 16:9 Aspect Ratio
          backgroundColor: "rgba(0,0,0,0.05)",
          overflow: "hidden",
        }}
      >
        <CardMedia
          component="img"
          image={data?.frame}
          alt={data?.metadata?.camera_id || "Camera Frame"}
          sx={{
            position: "absolute",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            objectFit: "contain",
            backgroundColor: "#000",
          }}
        />
      </Box>

      <CardContent sx={{ flexGrow: 1, p: 2 }}>
        <Typography variant="h6" fontWeight="bold" color="primary" noWrap>
          Camera {data?.metadata?.name || data?.metadata?.camera_id || "Unknown"}
        </Typography>

        <Box display="flex" justifyContent="space-between" mt={1}>
          <Typography variant="body2" color="text.secondary">
            📅 {data?.metadata?.date || "—"}
          </Typography>
          <Typography variant="body2" color="text.secondary">
            ⏰ {data?.metadata?.time || "—"}
          </Typography>
        </Box>

        <Divider sx={{ my: 1 }} />

        <Typography variant="body2" fontWeight="bold">
          🧑‍🤝‍🧑 People Count: {data?.metadata?.person_count ?? 0}
        </Typography>
      </CardContent>
    </Card>
  );
}
